import { Skeleton } from '@monksflow/monks-ui';

/**
 * Pane-region placeholder while the deep-link seam resolves. Mirrors
 * `FolderGuidelinesPane`'s own pending-state skeleton shape so the region
 * does not visibly jump once resolution settles into that same pane.
 */
export function GuidelinesPaneLoading() {
  return (
    <div className="flex min-h-0 flex-1 flex-col gap-xl rounded-lg bg-card p-xl">
      <div className="flex items-start gap-md">
        <Skeleton className="size-14 shrink-0 rounded-sm" />
        <div className="flex min-w-0 flex-1 flex-col gap-3xs">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-5 w-48" />
        </div>
      </div>
      <Skeleton className="h-10 w-[420px]" />
      <Skeleton className="h-64 w-full" />
    </div>
  );
}

GuidelinesPaneLoading.displayName = 'GuidelinesPaneLoading';
